var map = {
	"./directives/templates/addFriends.html": 4742,
	"./directives/templates/chatAbuseReport.html": 5707,
	"./directives/templates/chatAvatarHeadshot.html": 6492,
	"./directives/templates/chatBar.html": 5307,
	"./directives/templates/chatBase.html": 1254,
	"./directives/templates/chatDialog.html": 5244,
	"./directives/templates/chatGameIcon.html": 5016,
	"./directives/templates/chatGroupDialog.html": 3578,
	"./directives/templates/chatPlaceholder.html": 7999,
	"./directives/templates/confirmNegativeAction.html": 5430,
	"./directives/templates/conversationTitle.html": 6125,
	"./directives/templates/conversationTitleEditor.html": 1108,
	"./directives/templates/createChatGroup.html": 8061,
	"./directives/templates/details.html": 6203,
	"./directives/templates/dialogHeader.html": 185,
	"./directives/templates/dialogMinimize.html": 2553,
	"./directives/templates/displayMessage.html": 4040,
	"./directives/templates/gamesList.html": 3400,
	"./directives/templates/linkCard.html": 4148,
	"./directives/templates/selectFriends.html": 5015,
	"./directives/templates/systemMessage.html": 2674,
	"./directives/templates/userConversationInfo.html": 4174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4850;